import BaseInput from 'Components/Form/BaseInput';
import { Controller, RegisterOptions } from 'react-hook-form';
import Select from 'react-select';
export interface MultipleSelectInputProps extends ISelectField {
  labelIcon?: React.ReactNode;
  rules?: RegisterOptions;
  menuPlacement?: 'auto' | 'bottom' | 'top';
}
export const MultipleSelectInput = ({
  name,
  options,
  rules,
  placeholder,
  menuPlacement = 'auto',
  ...rest
}: MultipleSelectInputProps) => {
  return (
    <>
      {name && (
        <BaseInput name={name} {...rest}>
          {({ control }) => (
            <Controller
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  isMulti
                  menuPlacement={menuPlacement}
                  classNamePrefix="ReactSelect"
                  options={options}
                  ref={ref}
                  value={options.filter((option) =>
                    value?.includes(option.value),
                  )}
                  onChange={(options) =>
                    onChange(options?.map((option) => option.value))
                  }
                />
              )}
              name={name}
              rules={rules}
              control={control}
              defaultValue=""
            />
          )}
          {/* {({ register }) => (
            <>
              <select
                {...register(name, rules)}
                className="text-red form-select bg-transparent text-sm block w-full h-12 px-4 rounded-xl border border-gray-100  focus:outline-none focus:border focus:border-gray appearance-none bg-select-arrow bg-no-repeat	bg-right-1"
              >
                <option disabled selected value="">
                  {placeholder}
                </option>
                {options.map(({ label, value }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </>
          )} */}
        </BaseInput>
      )}
    </>
  );
};
